import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Nouvelle commande {{method}} !',
        scheduled: 'Commande {{method}} planifiée !',
        on_site: 'Nouvelle commande à table !',
        // Table orders are ASAP; this is for room-service orders scheduled before the rename.
        on_site_scheduled: 'Commande planifiée à table !',
      },
      labels: {
        today: "aujourd'hui",
        time_remaining_to_accept: 'restant pour accepter',
      },
      time_tag: {
        [OrderMethod.Pickup]: {
          asap: '🕓 Retrait dans {{time}}',
          scheduled: '🕓 Retrait {{day}} à {{time}}',
          scheduled_today: "🕓 Retrait aujourd'hui à {{time}}",
        },
        [OrderMethod.Delivery]: {
          asap: '🕓 Livraison dans {{time}}',
          scheduled: '🕓 Livraison {{day}} à {{time}}',
          scheduled_today: "🕓 Livraison aujourd'hui à {{time}}",
        },
        [OrderMethod.OnSite]: {
          // No 🕓: the screen draws the design's clock icon for table orders.
          asap: 'Service dans {{from}}–{{to}} min',
          scheduled: 'Service {{day}} à {{time}}',
          scheduled_today: "Service aujourd'hui à {{time}}",
        },
      },
      time_tag_estimated: {
        asap: '🕓 Estimation retrait : {{time}}',
        scheduled: '🕓 Estimation retrait : {{day}} à {{time}}',
      },
      buttons: {
        confirm_order: 'Confirmer la commande',
        cancel_order: 'Annuler la commande',
      },
      feedback: {
        rough_estimate_warning:
          "Il s'agit d'une estimation approximative. Vous recevrez le temps de préparation réel une fois un livreur assigné et l'heure de livraison confirmée. À ce moment, votre ticket sera imprimé automatiquement.",
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Temps de préparation',
      labels: {
        today: "aujourd'hui",
        order_time: {
          [OrderMethod.Delivery]: {
            asap: 'Livraison dans',
            scheduled: 'Livraison le',
            scheduled_today: 'Livraison',
          },
          [OrderMethod.Pickup]: {
            asap: 'Retrait dans',
            scheduled: 'Retrait le',
            scheduled_today: 'Retrait',
          },
          [OrderMethod.OnSite]: {
            asap: 'Service dans',
            scheduled: 'Service le',
            scheduled_today: 'Service',
          },
        },
        can_you_make_it: 'Pouvez-vous y arriver ?',
        we_also_send_this_update_to_the_customer: 'Nous envoyons aussi cette mise à jour au client',
      },
      buttons: {
        yes_lets_go: "Oui, c'est parti !",
        no_change_time: "Non, changer l'heure",
        confirm: 'Confirmer',
      },
      toasts: {
        order_confirmed: {
          title: 'Commande #{{number}} confirmée',
          body: 'Ne préparez pas encore ! Nous vous préviendrons quand un livreur est assigné.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          "Malheureusement, la livraison doit être annulée car le livreur n'est pas disponible. Cliquez sur les trois points en haut à droite pour annuler la commande et rembourser le client.",
        [BackendErrorCode.DeliveryProviderException]:
          "Malheureusement, la livraison doit être annulée car le livreur n'est pas disponible. Cliquez sur les trois points en haut à droite pour annuler la commande et rembourser le client.",
        [BackendErrorCode.DeliveryDispatchRetrying]:
          "Commande acceptée, mais aucun livreur n'est encore réservé. Nous réessayons pendant 15 minutes et vous préviendrons si aucun n'est trouvé.",
      },
    },
  },
  error_messages: {
    something_went_wrong: "Une erreur s'est produite, veuillez réessayer",
  },
};
